var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-3xl ppv2-p-6"},[_c('Header',{attrs:{"title":_vm.$t('promotions.title_promotion')}}),_vm._v(" "),_c('bo-marketing-promotion-table',{attrs:{"token":_vm.token},on:{"edit":_vm.goToEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }